import React from 'react';
import styled from 'styled-components';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';
import {
  SavedForLater,
  Keywords,
  CandidateFiltersGroupLayout,
  ExperienceContent,
  useExperienceState,
} from 'talent_matching/components/filters';

import WorkPreferencesFiltersGroup from './work_preferences_filters_group';
import MyGreenhouseAppliedFilters from './my_greenhouse_applied_filters';

const t = withLocalePrefix('talent_matching.filter_row');

const NoWrap = styled(Stack)`
  white-space: nowrap;
`;

type Props = {
  onClearAll: () => void;
  children: React.ReactNode;
};

const MyGreenhouseFilterRow = ({ onClearAll, children }: Props) => {
  const experienceState = useExperienceState();

  return (
    <Stack spacing={0} sx={{ marginBottom: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <NoWrap spacing={1} direction="row" alignItems="center" flexWrap="wrap">
          <SavedForLater />
          <CandidateFiltersGroupLayout
            appliedCount={experienceState.totalFiltersCount}
            onClear={() => experienceState.clear()}
          >
            <ExperienceContent state={experienceState} />
          </CandidateFiltersGroupLayout>
          <WorkPreferencesFiltersGroup />
          <Keywords />
          <TertiaryButton size="md" onClick={onClearAll}>
            {t('buttons.clear_all')}
          </TertiaryButton>
        </NoWrap>
        {children}
      </Stack>
      <MyGreenhouseAppliedFilters />
    </Stack>
  );
};

export default MyGreenhouseFilterRow;
